import { render, staticRenderFns } from "./use-elec-revenue-sharing.vue?vue&type=template&id=d81ede28&scoped=true&"
import script from "./use-elec-revenue-sharing.vue?vue&type=script&lang=js&"
export * from "./use-elec-revenue-sharing.vue?vue&type=script&lang=js&"
import style0 from "./use-elec-revenue-sharing.vue?vue&type=style&index=0&id=d81ede28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81ede28",
  null
  
)

export default component.exports